import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const YouTubeVideoCreatorsInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="YouTube Video Creators in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Build Your YouTube Presence</Subheading>}
        heading={
          <Heading>
            YouTube <span tw="text-primary-500">Video Creators</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our expert YouTube video creators in **Dubai**
            produce engaging, high-quality content to grow your channel and
            captivate audiences. From vlogs to branded ads, we leverage Dubai’s
            vibrant creator ecosystem to deliver videos that resonate globally.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video production setup
          "https://images.unsplash.com/photo-1504465039542-a4308c88248f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // YouTube creative filming
          "https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content creation with Dubai background
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Creating Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier YouTube Video Creation in Dubai"
        description="We craft content that drives views and subscribers."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Vlogs, tutorials, and ads tailored to your audience.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Expert Creators",
            description: "Skilled team with YouTube production expertise.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery for consistent uploads.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Growth",
            description: "Optimized videos to boost engagement.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Brand Alignment",
            description: "Content that reflects your unique identity.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Versatile Formats",
            description: "Shorts, vlogs, and branded campaigns.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our YouTube Video Creation Process"
        description={
          <Description>
            We create compelling YouTube content with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your channel goals and audience.</li>
              <li>Planning: Develop scripts, storyboards, and concepts.</li>
              <li>Filming: Use 4K equipment for professional visuals.</li>
              <li>
                Editing: Enhance with effects, audio, and YouTube optimization.
              </li>
              <li>Delivery: Provide ready-to-upload videos in your format.</li>
              <li>Support: Offer analytics and strategy for growth.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551847677-dc82d764e1eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content planning
          "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video editing
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Camera equipment filming
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="YouTube Wins in Dubai"
        description="Our videos have amplified channels and brands."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaign",
            description: "Drove 1M+ views for a branded YouTube ad.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Subscriber Surge",
            description: "Boosted a channel’s subscribers by 50%.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "98% satisfaction from YouTube clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow Your Channel?</Subheading>}
        heading="YouTube Video Creators in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset, premier YouTube video creators in
            Dubai, to produce captivating content that grows your audience and
            elevates your brand. Contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626368305730-9461fba72d6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Professional filming
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content creation
          "https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video production setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
